import { cn, useFormField } from '@wellesley/ui'

type FieldIconProps = {
  icon?: JSX.Element
  isFilled?: boolean
  disabled?: boolean
  isFocused?: boolean
}

const FieldIcon = ({ icon, isFocused, isFilled, disabled }: FieldIconProps) => {
  const { error } = useFormField()

  if (!icon) return null

  return (
    <div
      className={cn(
        'left-s [&>svg]:size-xxs absolute top-3.5 text-gray-400 transition-all',
        !!error?.message && 'text-red-500',
        isFocused && 'text-blue-600',
        isFilled && !isFocused && 'text-gray-900',
        disabled && 'text-gray-200',
      )}
    >
      {icon}
    </div>
  )
}

export default FieldIcon
